export const BASE_USER_DISPLAY_FRAG = /* GraphQL */ `
  fragment BaseUserDisplayFrag on base_user {
    id
    reference_id
    full_name
    is_blocked
    number
    external_reference_id
    photo {
      id
      url
    }
  }
`

export const BASE_USER_FRAG = /* GraphQL */ `
  fragment BaseUserFrag on base_user {
    id
    codename: reference_id
    name: full_name
    number
    is_blocked
    external_reference_id
    is_verified
    photo {
      id
      url
    }
    created_at
    companies {
      id
      company {
        id
        name
        display_name
        codename
      }
    }
    my_businesses {
      id
    }
    current_address {
      id
      raw_address
      state_region {
        code
      }
    }
  }
`

export const USERS = /* GraphQL */ `
  query Users($groups: [String!], $query: String) {
    base_user(
      where: {
        is_verified: { _eq: true }
        groups: { group: { name: { _in: $groups } } }
        _or: [
          { full_name: { _ilike: $query } }
          { number: { _ilike: $query } }
          { external_reference_id2: { _ilike: $query } }
        ]
      }
      order_by: { full_name: asc_nulls_last }
      limit: 15
    ) {
      ...BaseUserFrag
    }
  }
  ${BASE_USER_FRAG}
`

export const ALL_USERS = /* GraphQL */ `
  query AllUsers($groups: [String!], $query: String) {
    base_user(
      where: {
        groups: { group: { name: { _in: $groups } } }
        _or: [
          { full_name: { _ilike: $query } }
          { number: { _ilike: $query } }
          { external_reference_id2: { _ilike: $query } }
        ]
      }
      order_by: { full_name: asc_nulls_last }
      limit: 15
    ) {
      ...BaseUserFrag
    }
  }
  ${BASE_USER_FRAG}
`

export const USERS_DETAIL = /* GraphQL */ `
  query UsersDetail($id: Int!) {
    base_user_by_pk(id: $id) {
      ...BaseUserFrag
    }
  }
  ${BASE_USER_FRAG}
`

export const BASE_USER_SEARCH = /* GraphQL */ `
  query SearchBaseUsers($groups: [String!], $query: String) {
    base_user(
      where: {
        groups: { group: { name: { _in: $groups } } }
        _or: [
          { full_name: { _ilike: $query } }
          { number: { _ilike: $query } }
          { external_reference_id2: { _ilike: $query } }
        ]
      }
      order_by: { full_name: asc_nulls_last }
      limit: 15
    ) {
      ...BaseUserFrag
    }
  }
  ${BASE_USER_FRAG}
`

export const SEARCH_BASE_USER_ID = /* GraphQL */ `
  query SearchBaseUserId($query: String) {
    base_user(
      where: { _or: [{ external_reference_id2: { _ilike: $query } }] }
      limit: 1
    ) {
      id
      full_name
      reference_id
    }
  }
  ${BASE_USER_FRAG}
`
